import {
  AccountBalanceTwoTone,
  AnnouncementTwoTone,
  AssignmentTwoTone,
  HomeTwoTone,
  ImportExportTwoTone,
  MemoryTwoTone,
  NotificationsTwoTone,
  PeopleTwoTone,
  SettingsRemoteTwoTone,
  SpeedTwoTone,
  StorageTwoTone,
} from '@mui/icons-material'

import { KARMA_Route } from '@/types/karma/route'

import {
  AllDashboards,
  AllFolders,
  AllNews,
  AllNotifications,
  AllSensors,
  AllUsers,
  AllVSensors,
  Calculon,
  DataGenerator,
  Diagnostics,
  EditFolder,
  EditNews,
  EditNotification,
  EditOperator,
  EditSensor,
  EditUser,
  EditVSensor,
  ExportPDF,
  ExportXLS,
  HomeFolder,
  ImportData,
  InstallationDetail,
  IO,
  LoginPage,
  MissingMeasurements,
  Overview,
  Payloads,
  PerformanceDetail,
  RecalculateData,
  SensorPrice,
  SingleFolder,
  SingleNews,
  UserRegister,
} from '../pages'

const routes: KARMA_Route[] = [
  /* Overview */
  {
    component: Overview,
    icon: <HomeTwoTone />,
    name: 'Übersicht',
    path: '/',
  },

  /* Dashboard */
  {
    component: AllDashboards,
    icon: <SpeedTwoTone />,
    name: 'Dashboard',
    path: '/dashboard',
  },

  /* special pages */
  { component: EditOperator, hidden: true, path: '/user-page/:tabId' },
  { component: EditOperator, hidden: true, path: '/user-page' },
  {
    component: UserRegister,
    hidden: true,
    path: '/pages/register-page',
    short: 'Register',
  },
  {
    component: LoginPage,
    hidden: true,
    path: '/pages/login-page',
    short: 'Login',
  },

  /* Exports / Imports */
  {
    component: ExportPDF,
    hidden: true,
    path: '/io/export-pdf/:folder_id',
  },
  {
    component: ExportXLS,
    hidden: true,
    path: '/io/export-xls',
  },
  {
    component: ExportPDF,
    hidden: true,
    icon: <AssignmentTwoTone />,
    name: 'Berichte',
    path: '/io/export-pdf',
  },
  {
    component: RecalculateData,
    hidden: true,
    icon: <StorageTwoTone />,
    isAdmin: true,
    path: '/io/import-sensordata',
  },
  {
    component: IO,
    icon: <ImportExportTwoTone />,
    name: 'Exporte',
    path: '/io',
  },

  /* Notifications */
  {
    component: EditNotification,
    hidden: true,
    isAdmin: true,
    path: '/notifications/:id/edit',
  },
  {
    component: EditNotification,
    hidden: true,
    isAdmin: true,
    path: '/notifications/new',
  },
  {
    component: AllNotifications,
    icon: <NotificationsTwoTone />,
    isAdmin: true,
    name: 'Benachrichtigungen',
    path: '/notifications',
  },

  /* Folder */
  { component: EditFolder, hidden: true, isAdmin: true, path: '/folder/new' },
  {
    component: PerformanceDetail,
    hidden: true,
    path: '/folder/:id/detail/:type',
  },
  { component: HomeFolder, hidden: true, path: '/folder/:id/home/:category' },
  {
    component: InstallationDetail,
    hidden: true,
    path: '/folder/:id/installation/:installationid',
  },
  {
    component: EditFolder,
    hidden: true,
    isAdmin: true,
    path: '/folder/:id/edit/:section',
  },
  {
    component: EditFolder,
    hidden: true,
    isAdmin: true,
    path: '/folder/:id/edit',
  },
  {
    component: SingleFolder,
    hidden: true,
    isAdmin: true,
    path: '/folder/:id/:section',
  },
  {
    component: SingleFolder,
    hidden: true,
    isAdmin: true,
    path: '/folder/:id',
  },
  {
    component: AllFolders,
    icon: <AccountBalanceTwoTone />,
    isAdmin: true,
    name: 'Gebäude',
    path: '/folder',
  },

  /* Sensoren */
  {
    component: Calculon,
    hidden: true,
    isAdmin: true,
    path: '/sensors/calculon',
  },
  {
    component: SensorPrice,
    hidden: true,
    isAdmin: true,
    path: '/sensors/price',
  },
  {
    component: DataGenerator,
    hidden: true,
    isAdmin: true,
    path: '/sensors/missing-data-query-generator',
  },
  {
    component: Payloads,
    hidden: true,
    isAdmin: true,
    path: '/sensors/payloads/:device_id',
  },
  {
    component: Payloads,
    hidden: true,
    isAdmin: true,
    path: '/sensors/payloads',
  },
  {
    component: MissingMeasurements,
    hidden: true,
    isAdmin: true,
    path: '/sensors/:id/missing',
  },
  {
    component: ImportData,
    hidden: true,
    isAdmin: true,
    path: '/sensors/:id/import',
  },
  {
    component: EditSensor,
    hidden: true,
    isAdmin: true,
    path: '/sensors/:id',
  },
  {
    component: AllSensors,
    icon: <MemoryTwoTone />,
    isAdmin: true,
    name: 'Sensoren',
    path: '/sensors',
  },

  /* Virtual Sensors */
  {
    component: EditVSensor,
    hidden: true,
    isAdmin: true,
    path: '/virtualsensors/:id/edit',
  },
  {
    component: EditVSensor,
    hidden: true,
    isAdmin: true,
    path: '/virtualsensors/new',
  },
  {
    component: AllVSensors,
    hidden: true,
    icon: <SettingsRemoteTwoTone />,
    isAdmin: true,
    path: '/virtualsensors',
  },

  /* News */
  {
    component: SingleNews,
    hidden: true,
    isAdmin: true,
    path: '/news/:id/:nc',
  },
  {
    component: EditNews,
    hidden: true,
    isAdmin: true,
    path: '/news/:id/edit',
  },
  {
    component: EditNews,
    hidden: true,
    isAdmin: true,
    path: '/news/new',
  },
  {
    component: AllNews,
    icon: <AnnouncementTwoTone />,
    isAdmin: true,
    name: 'News',
    path: '/news',
  },

  /* Users */
  {
    component: EditUser,
    hidden: true,
    isAdmin: true,
    path: '/users/:id/edit',
  },
  {
    hidden: true,
    isAdmin: true,
    path: '/users/:id',
    pathTo: '/users/:id/edit',
    redirect: true,
  },
  {
    component: EditUser,
    hidden: true,
    isAdmin: true,
    path: '/users/new',
  },
  {
    component: AllUsers,
    icon: <PeopleTwoTone />,
    isAdmin: true,
    name: 'Benutzer',
    path: '/users',
  },

  /* Env infos */
  {
    component: Diagnostics,
    hidden: true,
    icon: <AssignmentTwoTone />,
    isAdmin: true,
    path: '/about',
  },

  /* Fallback */
  {
    path: '/',
    pathTo: '/',
    redirect: true,
  },
]

export default routes
